import { getArticles } from 'api/articles'
import { Carousel, CarouselProps } from './Carousel'
import { queryConfig } from 'constants/homepage'
import { useQuery } from 'react-query'
import { ArticleCard } from 'components/editorial/cards/ArticleCard'
import qs from 'qs'
import { IArticle } from '@/types'

interface ArticlesCarouselProps extends CarouselProps {
  articles?: IArticle[] | null
  filterKeywords?: string
}

export const ArticlesCarousel = ({
  articles: initialArticles,
  filterKeywords,
  title,
  ...props
}: ArticlesCarouselProps) => {
  const { data: articles } = useQuery(
    'articles',
    async () => await fetchArticles(filterKeywords),
    {
      ...queryConfig,
      initialData: initialArticles,
    }
  )

  if (!articles?.length) return null

  return (
    <Carousel title={title || 'More articles'} {...props}>
      {articles?.map((article, index) => (
        <ArticleCard
          key={index}
          article={article}
          className='min-w-[264px] sm:min-w-[288px] md:min-w-[333px] lg:min-w-[298px] xl:min-w-[284px] 2xl:min-w-[276px]'
        />
      ))}
    </Carousel>
  )
}

const fetchArticles = async (filterKeywords?: string) => {
  const query = qs.stringify(
    {
      populate: [
        'seo',
        'thumbnailImage',
        'thumbnailImage.image',
        'category',
        'articleImage',
        'articleImage.image',
        'tags',
      ],
      filters: {
        category: {
          name: { $containsi: filterKeywords },
        },
      },
    },
    {
      encodeValuesOnly: true,
    }
  )

  const articles = await getArticles(query)
  return articles.data
}
